
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getLocationInfo, getYourInformationResults } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { aboutAffiantCsvDataInfoType, aboutServiceCsvDataInfoType } from '@/types/Application/CertificateOfService';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form7Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false; 
    existingFileNumber = '';  
   
    yourInfo = {} as yourInformationInfoDataInfoType;
    servedPersonName = '';
    serviceDate = '';
    serviceTime = '';
    
    documentList = [];
    documentListComment = '';
    serviceDetails = '';    
    personalServiceMethod = '';
    personalServiceMethodComment = '';
    ordinaryServiceMethod = '';
    ordinaryServiceMethodComment = '';
    mailServiceDate = '';
    
    mounted(){
        this.dataReady = false;
        console.log(this.result)
        this.extractInfo();       
        this.dataReady = true;        
    }
   
    public extractInfo(){        
        this.getAffiantInfo();  
        this.getServiceInfo();
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        
    } 

    public getAffiantInfo(){ 

        this.yourInfo = {} as yourInformationInfoDataInfoType;
        
        if(this.result?.aboutAffiantCsvSurvey){

            let aboutAffiant = {} as aboutAffiantCsvDataInfoType;
            aboutAffiant = this.result.aboutAffiantCsvSurvey;
            this.yourInfo = getYourInformationResults(aboutAffiant);
        }
            
    }

    public getServiceInfo(){  

        this.servedPersonName = '';
        this.serviceDate = '';
        this.serviceTime = '';      
        let serviceAddress = '';
        let otherServiceLocation = '';
        let serviceEmail = '';
        let serviceFax = '';
        let servicePhone = '';
        this.documentList = [];
        this.documentListComment = '';
        this.serviceDetails = '';    
        this.personalServiceMethod = '';
        this.personalServiceMethodComment = '';
        this.ordinaryServiceMethod = '';
        this.ordinaryServiceMethodComment = '';
        this.mailServiceDate = '';

        if(this.result?.aboutServiceCsvSurvey){

            const serviceData: aboutServiceCsvDataInfoType = this.result.aboutServiceCsvSurvey;
            
            this.servedPersonName = serviceData.ServedPersonName?Vue.filter('getFullName')(serviceData.ServedPersonName):'';
            
            if(serviceData.dateTimeServed){
                this.serviceDate = Vue.filter('beautify-date')(serviceData.dateTimeServed);
                this.serviceTime = Vue.filter('convert-date-time24to12')(serviceData.dateTimeServed);                           
            }

            if(serviceData.locationServed){

                const addressInfo = serviceData.locationServed
                const addressText = addressInfo.street + ', ' 
                                    + addressInfo.city + ', ' 
                                    + addressInfo.state + ', ' 
                                    + addressInfo.country + ', ' 
                                    + addressInfo.postcode;
                serviceAddress = addressText;
            } 
            
            otherServiceLocation = serviceData.otherServiceLocation?.length>0? 'other: '+ serviceData.otherServiceLocation:'';
            serviceEmail = serviceData.serviceContact?.email?.length>0? 'email: '+ serviceData.serviceContact?.email:'';
            serviceFax = serviceData.serviceContact?.fax?.length>0? 'fax: '+ serviceData.serviceContact?.fax:'';
            servicePhone = serviceData.serviceContact?.phone?.length>0? 'phone: '+ serviceData.serviceContact?.phone:'';

            this.serviceDetails = serviceAddress + ' ' + serviceEmail + ' ' + serviceFax + ' ' + servicePhone + ' ' + otherServiceLocation;
            
            this.documentList = serviceData.documentListCsv?serviceData.documentListCsv:[];
            this.documentListComment = (this.documentList.includes('other')&&serviceData.documentListCsvComment)?serviceData.documentListCsvComment:''; 
           
            this.personalServiceMethod = serviceData.personalServiceMethod;
            this.personalServiceMethodComment = (serviceData.personalServiceMethod == 'other' && serviceData.personalServiceMethodComment)?serviceData.personalServiceMethodComment:'';
        
            this.ordinaryServiceMethod = serviceData.ordinaryServiceMethod.selected;
            this.ordinaryServiceMethodComment = (this.ordinaryServiceMethod == 'other' && serviceData.ordinaryServiceMethod.otherComment)?serviceData.ordinaryServiceMethod.otherComment:'';
            this.mailServiceDate = (this.ordinaryServiceMethod == 'ordinaryMail' && serviceData.ordinaryServiceMethod.mailServiceDate)?Vue.filter('beautify-date')(serviceData.ordinaryServiceMethod.mailServiceDate):'';
            
        
        }
    
}  

   

 
}
